import React from 'react'

import PropTypes from 'prop-types'

import { brandSecondary } from '../../utils/style-utils'
import Circle from '../Icons/Circle'
import CircleSolid from '../Icons/CircleSolid'
import { CircularProgress } from '../ProgressBar/CircularProgress'
import Wrapper from './CircleWrapper'

export function NavigationCircle({ isActive, onClick, duration, paused }) {
  const Icon = isActive ? CircleSolid : Circle

  return (
    <Wrapper
      isActive={isActive}
      onClick={() => !isActive && onClick()}
    >
      {isActive && !paused ? (
        <CircularProgress
          size={24}
          speed={`${duration / 1000}s`}
          strokeWidth={10}
          color={brandSecondary}
        />
      ) : null}
      <Icon />
    </Wrapper>
  )
}

NavigationCircle.propTypes = {
  isActive: PropTypes.bool,
  duration: PropTypes.number,
  onClick: PropTypes.func,
  paused: PropTypes.bool,
}
